import React, { useEffect } from "react";
import "./aboutUs.scss";
import CommonBanner from "../../components/commonBanner/CommonBanner";
import {
  aboutSec01,
  aboutSec02,
  flower,
  images,
  mbAboutSec01,
  sun,
  upDownArrow,
} from "../../source";
import ColourBoxes from "../../components/ColourBoxes/ColourBoxes";
import { missionVissionData, partnerLogoData } from "../../data/about";
import ImageContentBox from "../../components/ImageContentBox/ImageContentBox";
import PartnersLogo from "../../components/PartnersLogo/PartnersLogo";
import { useWindowSize } from "react-use";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const founderData = [
  {
    title: "Marouf Tirad",
    description: [
      "Meet <strong>Marouf,</strong> the passionate host and dedicated contributor behind Pathways & Perspectives. With academic interests deeply rooted in <strong>philosophy</strong> and a practical foundation forged through a <strong>life in business,</strong> Marouf brings a unique lens to exploring profound wisdom and guiding meaningful conversations.",
      "Beyond his professional life, Marouf is a devoted wellness, yoga, car racing, and cycling enthusiast. Since 2023, he has further deepened his path through immersive yoga studies in the Himalayas, a journey that has challenged many philosophical belief systems he'd encountered, emphasizing the transformative power of self-discovery and knowing. This profound spiritual and cultural immersion has significantly shaped his approach to <strong>holistic well-being</strong> and personal growth.",
      "Marouf's vision for Pathways & Perspectives is born from a shared desire to explore and unravel the <strong>deep and actionable life wisdom</strong> gathered from the remarkable teachers, masters, and individuals encountered on this collective journey. As we dive into diverse perspectives and timeless truths, Marouf is eager to <strong>seek wisdom, dive deep, and unravel new paths together,</strong> fostering a community of learning, growth, and cultural appreciation. He believes that by <strong>exploring and sharing</strong> these insights, we can truly empower our inner growth to shape our outer reality, creating something genuinely useful and enjoyable for all.",
    ],
    link: "https://www.linkedin.com/",
  },
];

const AboutUs = () => {
  const { width } = useWindowSize();

  const missionVissionList = missionVissionData.map((item, i) => (
    <div className="col-md-6 colour_box_col" key={i} data-aos="fade-up">
      <ColourBoxes
        bgImg={item.img}
        icon={item.icon}
        title={item.title}
        description={item.desc}
        bgColor={item.bgColor}
      />
    </div>
  ));

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Our Story & Mission | Holistic Healing & Coaching- Pathways & Perspectives"
        metaDesc="Discover the mission and vision behind Pathways & Perspectives. Learn how our holistic approach to healing and coaching empowers individuals to grow, heal, and thrive."
      />

      <section className="about_sec1">
        <CommonBanner title="About Us" linkText1="About" />
      </section>

      <section className="about_sec2">
        <div className="my_container">
          <div className="row about_row">
            <div className="col-lg-5 about_col" data-aos="fade-up">
              <div className="content_wrapper">
                <h2 className="section_heading100">
                  Welcome to Pathways & Perspectives
                </h2>
                <p className="section_desc22">
                  In a world hungry for meaning, we provide a unique space where
                  diverse voices converge to share{" "}
                  <strong>deep and actionable life wisdom.</strong> Whether
                  you're navigating personal challenges, seeking spiritual
                  growth, or simply looking for fresh inspiration, our
                  interviews offer new insights and perspectives that empower
                  you to create a life of purpose. Here, you'll find profound
                  insights and guidance from accomplished mentors –{" "}
                  <strong>some you know, some you'll discover.</strong> We delve
                  into ancient wisdom in a modern context, revealing insights
                  that are both timeless and practical. Join our community and
                  discover your own{" "}
                  <strong>path to freedom, clarity, and well-being.</strong>
                </p>
              </div>
            </div>

            <div className="col-lg-7 about_col" data-aos="fade-up">
              <div className="img_wrapper">
                <div className="img_box">
                  <img
                    src={width > 767 ? aboutSec01 : mbAboutSec01}
                    alt="about"
                    className="about_img about_img1"
                  />
                </div>
                {width > 767 && (
                  <div className="img_box">
                    <img
                      src={aboutSec02}
                      alt="about"
                      className="about_img about_img2"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about_sec3">
        <div className="my_container">
          <div className="row colour_box_row">{missionVissionList}</div>
        </div>
      </section>

      <section className="about_sec4">
        <div className="my_container">
          <img src={sun} alt="sun" className="bg_img" />
          {/* <img src={upDownArrow} alt="sun" className="bg_down_img" /> */}
          {width > 767 && (
            <img src={flower} alt="sun" className="bg_flower_img" />
          )}
          <h2 className="section_heading100" data-aos="fade-up">
            Meet The Host
          </h2>
          <ImageContentBox
            img={images.founder.image}
            ImageContentData={founderData}
          />
        </div>
      </section>

      {/* <section className="about_sec5">
        {width > 767 && (
          <img src={flower} alt="sun" className="bg_flower_img" />
        )}
        <div className="my_container">
          <h2 className="section_heading100" data-aos="fade-up">Our Valued Partners</h2>
          <PartnersLogo partnerLogo={partnerLogoData} />
        </div>
      </section> */}
    </>
  );
};

export default AboutUs;
